import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { UpdateFormValuesInput } from './schema';

export const useInitialValues = (id: string): UpdateFormValuesInput => {
    const { data } = useRepositorySuspenseQuery('verifactuFiscalRegistryIntegration', 'get', { id });

    return {
        ...data,
        name: data.name ?? '',
        companyName: data.companyName ?? '',
        taxIdentificationNumber: data.taxIdentificationNumber ?? '',
        isEnabled: data.isEnabled ? ['true'] : [],
    };
};
